export const AppModel = {
	title: 'engati chatbot',
	position: 'bottomright',
};

export const LAUNCHER_POSITION = {
	RIGHT: 'bottomright',
	LEFT: 'bottomLeft',
};

export const LAUNCHER_POSITION_CSS = {
	[LAUNCHER_POSITION.RIGHT]: 'engt-right-theme',
	[LAUNCHER_POSITION.LEFT]: 'engt-left-theme',
};
